import React, { useEffect, useState } from "react";
import "./Category.css";
import { NavLink } from "react-router-dom";
import logoImg from "../logo.svg";
import { Icon } from "react-icons-kit";
import { menu } from "react-icons-kit/feather/menu";
import { arrowUp } from "react-icons-kit/feather/arrowUp";
import { trash } from "react-icons-kit/feather/trash";
import { eye } from "react-icons-kit/feather/eye";
import { arrowUpRight } from "react-icons-kit/feather/arrowUpRight";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from "../components/Sidebar";
import { useJwt } from "react-jwt";
import { DeleteEmployee, GetEmployePage } from "../apiconfig/authService";
import { Pagination } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { RiLoaderFill } from "react-icons/ri";
import { toast } from "react-toastify";

function Employee() {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem("accessToken"));
  if (isExpired) navigate("/");

  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [employeesData, setEmployeesData] = useState([]);
  const [searchedEmployeesData, setSearchedEmployeesData] = useState([]);
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [recordIdToDelete, setRecordIdToDelete] = useState("");
  const [loading, setLoading] = useState(false);
  const [refetchData, setRefetchData] = useState(false);

  const handlePerPageRecordsChange = (e) => {
    setItemsPerPage(e.target.value);
    setPageCount(1);
  };

  const formatUTCDate = (utcDateString) => {
    const date = new Date(utcDateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // convert 0 → 12, 13 → 1, etc.
    hours = String(hours).padStart(2, "0");

    return `${day}-${month}-${year} at ${hours}:${minutes}:${seconds} ${ampm}`;
  };

  useEffect(() => {
    setSearchedEmployeesData(
      employeesData?.filter(
        (item) =>
          item?.firstname?.includes(search) ||
          item?.lastname?.includes(search) ||
          item?.emailid?.includes(search)
      )
    );
  }, [search, employeesData]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const response = await GetEmployePage(
          page,
          itemsPerPage,
          localStorage.getItem("accessToken")
        );
        setLoading(false);
        setEmployeesData([...response.data.items]);
        setSearchedEmployeesData([...response.data.items]);
        setTotalEmployees(response.data.pagination.count);
        setPageCount(Math.ceil(response.data.pagination.pageCount));
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [page, itemsPerPage, refetchData]);

  const handleDeleteEmployeeClick = async (emailid) => {
    try {
      setLoading(true);
      await DeleteEmployee(emailid, localStorage.getItem("accessToken"));
      setRefetchData((prev) => !prev);
      toast.success("Employee Deleted Successfully!");
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewCategoryClick = (emailid) => {
    navigate(`/viewEmployee/${emailid}`);
  };
  const handleEditCategoryClick = (emailid) => {
    navigate(`/editEmployee/${emailid}`);
  };

  const handlePrevious = () => {
    setPage((p) => {
      if (p === 1) return p;
      return p - 1;
    });
  };
  const handleNext = () => {
    setPage((p) => {
      if (p === pageCount) return p;
      return p + 1;
    });
  };

  return (
    <div className="dashboard-content">
      <Sidebar />
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">
            Employee Management
            <br />
            <small className="text-primary h6 fw-bold">
              Total counts {totalEmployees}
            </small>
          </h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/addEmployee" className="btn btn-primary addSeller">
              Add Employee
            </NavLink>
          </div>
        </div>
        <div className="collapse mb-4" id="filter">
          <div className="card card-body">
            <form className="filterForm" action="/">
              <div className="row">
                <div className="col-lg-12 mb-2">
                  <h4 className="text-primary h6 fw-bold">Filter Things</h4>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 mb-2">
                  <div className="form-floating">
                    <select
                      className="form-select"
                      id="floatBilling"
                      aria-label="Billing"
                    >
                      <option defaultValue>Select</option>
                      <option value="1">One</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select>
                    <label htmlFor="floatBilling">Billing</label>
                  </div>
                </div>
                <div className="col-lg-4 mb-2">
                  <div className="form-floating">
                    <select
                      className="form-select"
                      id="floatStatus"
                      aria-label="Status"
                    >
                      <option defaultValue>Select</option>
                      <option value="1">One</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select>
                    <label htmlFor="floatStatus">Status</label>
                  </div>
                </div>
                <div className="col-lg-4 mb-2">
                  <button
                    type="submit"
                    className="btn btn-primary btn-lg save-btn text-uppercase w-100"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="searchList row">
          <div className="displayRecord d-flex align-items-center col-lg-6 mb-2">
            <span className="h6 mb-0">Display Records</span>
            <select
              className="form-select"
              value={itemsPerPage}
              onChange={handlePerPageRecordsChange}
            >
              <option defaultValue="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="500">500</option>
            </select>
          </div>
          <div className="searchForm d-flex justify-content-end col-lg-6 mb-2">
            <form className="sForm">
              <input
                type="text"
                onChange={(event) => {
                  setSearch(event.target.value);
                }}
                className="form-control form-control-lg w-100"
                id="s"
                placeholder="Search"
              />
            </form>
          </div>
        </div>
        {loading ?
          <div className="d-flex align-items-center justify-content-center">
            <RiLoaderFill size={40} className="text-success spin-animation text-center" />
          </div>
          :
          <div className="table-responsive">
            <table className="table table-borderless table-hover">
              <thead>
                <tr>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "50px",
                    }}
                    scope="col"
                    width="45"
                    align="center"
                  >
                    <div className="selectAll">
                      <input className="form-check-input" type="checkbox" />
                    </div>
                  </th>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "80px",
                    }}
                    scope="col"
                    width="80"
                  >
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">SR.</span>
                      <button className="filtBtn idFilter">
                      
                      </button>
                    </div>
                  </th>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "150px",
                    }}
                    scope="col"
                  >
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">First Name</span>
                      <button className="filtBtn fNameFilter">
                      
                      </button>
                    </div>
                  </th>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "150px",
                    }}
                    scope="col"
                  >
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">Last Name</span>
                      <button className="filtBtn lNameFilter">
                      
                      </button>
                    </div>
                  </th>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "200px",
                    }}
                    scope="col"
                  >
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">Employee code</span>
                      <button className="filtBtn statusFilter">
                      
                      </button>
                    </div>
                  </th>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "200px",
                    }}
                    scope="col"
                  >
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">Phone number</span>
                      <button className="filtBtn emailFilter">
                      
                      </button>
                    </div>
                  </th>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "200px",
                    }}
                    scope="col"
                  >
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">Designation</span>
                      <button className="filtBtn emailFilter">
                      
                      </button>
                    </div>
                  </th>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "300px",
                    }}
                    scope="col"
                  >
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">Email ID</span>
                      <button className="filtBtn emailFilter">
                      
                      </button>
                    </div>
                  </th>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "300px",
                    }}
                    scope="col"
                  >
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">Created Date</span>
                    </div>
                  </th>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "300px",
                    }}
                    scope="col"
                  >
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">Modified Date</span>
                    </div>
                  </th>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "300px",
                    }}
                    scope="col"
                  >
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">Created By</span>
                    </div>
                  </th>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "300px",
                    }}
                    scope="col"
                  >
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">Modified By</span>
                    </div>
                  </th>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "150px",
                    }}
                    scope="col"
                  >
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">Status</span>
                    </div>
                  </th>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "150px",
                    }}
                    scope="col"
                  >
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">Role</span>
                    </div>
                  </th>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "150px",
                    }}
                    scope="col"
                  >
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">Action</span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody className="table-group-divider">
                {searchedEmployeesData.map((item, index) => {
                  // Extract roles and statuses for the current item
                  const roles = item?.roleInfo?.map(
                    (roleItem) => roleItem?.rolename
                  );
                  const statuses = item?.statusInfo?.map(
                    (statusItem) => statusItem?.status
                  );

                  return (
                    <tr key={item?._id}>
                      <td>
                        <input className="form-check-input" type="checkbox" />
                      </td>
                      <td>{index + 1}</td>
                      <td>{item?.firstname}</td>
                      <td>{item?.lastname}</td>
                      <td>{item?.empcode}</td>
                      <td>{item?.employeephone}</td>
                      <td>{item?.designation}</td>
                      <td>{item?.emailid}</td>
                      <td>{formatUTCDate(item?.createddate)}</td>
                      <td>{formatUTCDate(item?.modifieddate)}</td>
                      <td>{item?.createdby}</td>
                      <td>{item?.modifiedby}</td>

                      <td>
                        {statuses.map((status, statusIndex) => (
                          <li key={statusIndex} style={{ listStyle: "none" }}>
                            {status}
                          </li>
                        ))}
                      </td>

                      <td>
                        {roles.map((role, roleIndex) => (
                          <li key={roleIndex} style={{ listStyle: "none" }}>
                            {role}
                          </li>
                        ))}
                      </td>

                      <td>
                        <div className="d-grid gap-2 d-md-block">
                          <button
                            type="button"
                            onClick={() => {
                              handleViewCategoryClick(item?.emailid);
                            }}
                            className="actBtn viewBtn"
                          >
                            <Icon className="eye" icon={eye} size={18} />
                            <span className="toolTip">Preview</span>
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              handleEditCategoryClick(item?.emailid);
                            }}
                            className="actBtn editBtn"
                          >
                            <Icon
                              className="arrowUpRight"
                              icon={arrowUpRight}
                              size={18}
                            />
                            <span className="toolTip">Edit</span>
                          </button>
                          &nbsp;
                          <button
                            type="button"
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                            onClick={() => {
                              setRecordIdToDelete(item?.emailid);
                            }}
                            className="actBtn delBtn"
                          >
                            <Icon className="trash" icon={trash} size={18} />
                            <span className="toolTip">Delete</span>
                          </button>
                          &nbsp;
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        }
        {loading || itemsPerPage === "all" ? null :
        <div className="resultList pt-3 border-top">
          <div className="row">
            <div className="d-flex justify-content-between displayRecord col mt-2">
              {/* <div className=" pb-[20px] pl-[20px] pr-[20px] w-full flex justify-between mt-3"> */}
              {totalEmployees === 0 ? (
                <div>Showing 0 - 0 of 0 entries. </div>
              ) : (
                <div>
                  Showing {(page - 1) * itemsPerPage + 1} -{" "}
                  {totalEmployees < itemsPerPage * page
                    ? totalEmployees
                    : itemsPerPage * page}{" "}
                  of {totalEmployees} entries.
                </div>
              )}
              {/* Pagination Start */}
              <div>
                <Pagination
                  prev
                  last
                  next
                  first
                  size="sm"
                  ellipsis
                  boundaryLinks
                  onSelect={setPage}
                  limit={Number(itemsPerPage)}
                  onChangeLimit={setItemsPerPage}
                  layout={["pager", "skip"]}
                  pages={pageCount}
                  total={totalEmployees}
                  maxButtons={5}
                  activePage={page}
                  onChangePage={(page) => {
                    setPage(page);
                  }}
                />
              </div>
              {/* Pagination End */}
            </div>
          </div>
        </div>
}
        <div
          className="modal fade"
          id="exampleModal"
          tabIndex="10"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body text-center p-5">
                <h1
                  className="modal-title display-6 mb-4"
                  id="exampleModalLabel"
                >
                  Proceed with delete?
                </h1>
                <button
                  type="button"
                  className="btn btn-danger me-2"
                  data-bs-dismiss="modal"
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    handleDeleteEmployeeClick(recordIdToDelete);
                  }}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Employee;
